import React, {createContext, useState} from 'react';
import Modal from "components/Modal";

export const ModalContext = createContext<Partial<any>>({});

export const ModalProvider = ({
                                  children,
                              }) => {
    const [open, setOpen] = useState(false);
    const [content, setContent] = useState(null);
    const [contentClasses, setContentClasses] = useState(null);
    const [fullscreen, setFullscreen] = useState(null);
    const [loading, setLoading] = useState(false);
    const [onClose, setOnClose] = useState(null);

    function openModal({fullscreen = false, content, classes = null, onClose = null}) {
        setContentClasses(classes);
        setOpen(true);
        setOnClose(onClose);
        setFullscreen(fullscreen);
        setContent(content);
    }

    function closeModal() {
        setOpen(false);
        setOnClose(null);
        setContent(null);
        setFullscreen(null);
        setContentClasses(null);
    }

    return (
        <ModalContext.Provider value={{
            openModal,
            closeModal,
            setContent,
            setLoading
        }}>
            <Modal
                fullscreen={fullscreen}
                open={open}
                onClose={() => {
                    setOpen(false);
                    onClose && onClose();
                }}
                loading={loading}
                content={content}
                contentClasses={contentClasses}/>
            {children}
        </ModalContext.Provider>
    );
};
